import { Controller } from "@hotwired/stimulus"
import { debugLog } from "../utils";

export default class extends Controller {
    static targets = ["input", "dot", "submitButton", "form"]

    connect() {
        this.updateDots()

        this.inputTarget.addEventListener("input", this.updateDots.bind(this))
        
        // Listen for form submission errors
        this.formTarget.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
    }

    disconnect() {
        this.inputTarget.removeEventListener("input", this.updateDots.bind(this))
        this.formTarget.removeEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
    }

    handleSubmitEnd(event) {
        // If submission failed (non-2xx response), clear the PIN
        if (!event.detail.success) {
            this.clearPin()
        }
    }

    clearPin() {
        // Clear the input value
        this.inputTarget.value = ""
        
        // Update dots to show empty state
        this.updateDots()
        
        // Optional: Add shake animation
        this.dotTargets.forEach(dot => {
            dot.classList.add("animate-shake")
            setTimeout(() => {
                dot.classList.remove("animate-shake")
            }, 500)
        })
    }

    updateDots() {
        const value = this.inputTarget.value || ""
        const length = value.length

        this.dotTargets.forEach((dot, i) => {
            const circle = dot.querySelector("circle")
            if (i < length) {
                circle.setAttribute("opacity", "1")
            } else {
                circle.setAttribute("opacity", "0.5")
            }
        })

        // enable/disable button
        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = length !== 4
            if (!this.submitButtonTarget.disabled) {
                this.formTarget.requestSubmit()
            }
            // if (this.submitButtonTarget.disabled) {
            //     this.submitButtonTarget.classList.remove("bg-black")
            //     this.submitButtonTarget.classList.add("bg-black/15")
            // }
            // else {
            //     this.submitButtonTarget.classList.remove("bg-black/15")
            //     this.submitButtonTarget.classList.add("bg-black")
            // }
        }
    }


}
